export default __webpack_public_path__ + "static/media/clients.8b7f6fad.svg";